import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { getSharedStyles } from "../../shared/shared-styles";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
interface LearningAnalysisStylesProps {
  isMobile: boolean;
}

export const useLearningAnalysisStyles = makeStyles<Theme, LearningAnalysisStylesProps>((theme) => ({
  loadingContainer: {
    padding: (props) => (props.isMobile ? "16px" : "24px"),
    textAlign: "center",
  },
  ...getSharedStyles(theme),

  insideHeader: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "20px",
  },
}));
